import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import { Typography } from '@mui/material';

export const UserRoleField = ({ record }) => {
    const translate = useTranslate();
    if (!record) return null;
    const roleName = translate(`resources.user.choices.role.${record.role}`, { _: record.role });
    return record.isActive ? (
        <Typography variant='body2' sx={{ width: '200px' }}>
            {roleName}
        </Typography>
    ) : (
        <Typography className='user-inactive' variant='body2' sx={{ width: '200px' }}>
            {translate('resources.user.labels.inactive')}
        </Typography>
    );
};

UserRoleField.propTypes = {
    record: PropTypes.shape({
        role: PropTypes.string,
        isActive: PropTypes.bool,
    }),
};
